<h1 mat-dialog-title class="text-center title" *ngIf="data.title">{{data.title}}</h1>
<div mat-dialog-content>
  <iframe [src]="documento" 
    style="width: 100%;height: 400px;border:0px">
    </iframe>

</div>
<div mat-dialog-actions class="d-flex justify-content-center">
  <button mat-raised-button (click)="closeConfirmDialog()" class="btn btn-serfor btn-xs color-white">Cerrar Documento</button>
  <!--<button mat-raised-button (click)="confirmDialog()" cdkFocusInitial color="primary"  >{{data.labelOk}}</button>-->
</div>